@let breakpoints = breakpoints$ | async;
@let settings = this.settings();
@if (permissions.isWalletsVisible()) {
  <pp-routing-item
    link="/wallets"
    iconName="wallet"
    i18nKey="shell.sidebar.nav.wallets" />
}

@if (permissions.isActivityVisible()) {
  <pp-routing-item
    link="/activity"
    iconName="activity"
    i18nKey="shell.sidebar.nav.activity" />
}

@if (permissions.isOrganizationsVisible()) {
  <pp-routing-item
    link="/teams"
    iconName="teams"
    i18nKey="shell.sidebar.nav.teams" />
}

@if (breakpoints.isDesktop && permissions.isUsersVisible()) {
  <pp-routing-item
    link="/users"
    iconName="users"
    i18nKey="shell.sidebar.nav.users" />
}

@if (permissions.isCardsVisible()) {
  <pp-routing-item
    link="/cards"
    iconName="cards"
    i18nKey="shell.sidebar.nav.cards"
    exactRoute />
}

@if (permissions.isPromoVisible()) {
  <pp-routing-item
    link="/promo"
    iconName="promo"
    i18nKey="shell.sidebar.nav.promo"
    exactRoute />
}

@if (breakpoints.isDesktop && permissions.isPayOrdersVisible()) {
  <pp-routing-item
    link="/pay-orders"
    iconName="pay-orders"
    i18nKey="shell.sidebar.nav.payOrders" />
}

<div class="spacer"></div>

@if (
  settings?.agent_feature_availability && permissions.isAgentAccountsVisible()
) {
  <pp-action-item
    iconName="agent-accounts"
    i18nKey="shell.sidebar.nav.agentAccount"
    (action)="startRedirectToAgentAccounts()">
  </pp-action-item>
}

<pp-routing-item
  link="/support"
  iconName="help"
  i18nKey="shell.sidebar.nav.support" />

<pp-action-item
  [iconName]="themeService.theme"
  (action)="themeService.toggleTheme()"
  [i18nKey]="themeTranslation">
</pp-action-item>

<pp-action-item
  (click)="logout()"
  iconName="logout"
  i18nKey="shell.sidebar.nav.logOut">
</pp-action-item>
